import { DateTime } from 'luxon';

import { TimeUnitOptions } from 'dashboard/models/graph-query';

type ParsedTimeFrameText = {
  startMoment: DateTime;
  endMoment: DateTime;
  periods: number;
  unit: TimeUnitOptions;
  errored: boolean;
};

export function parseRelativeText(text: string): ParsedTimeFrameText {
  const relativePattern = /^([p|l]ast\s+)?([0-9]*(\.[0-9]{1,2})?)?[\s+]?([a-z]+)$/gi;
  // some examples for `matchAll` return values:
  // `last 30.2 years` => Array [Array ["last 30.2 years", "last ", "30.2", ".2", "years"]]
  // `last year` => Array [Array ["last year", "last ", "", undefined, "year"]]
  const matches = [...text.matchAll(relativePattern)];

  let unit;
  let periods;
  let startMoment;
  let endMoment;
  let errored = true;

  if (matches[0]) {
    periods = getPeriods(matches[0][2]) || 1;
    unit = getUnit(matches[0][4]);
    if (unit && periods > 0) {
      endMoment = DateTime.local();
      /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
      startMoment = endMoment.minus({ [toMomentUnit(unit)]: periods });
      if (
        startMoment.isValid &&
        endMoment.isValid &&
        endMoment.valueOf() - startMoment.valueOf() > 0
      ) {
        errored = false;
      }
    }
  }

  return {
    /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
    unit,
    /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
    periods,
    /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
    startMoment,
    /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
    endMoment,
    errored,
  };
}

function getUnit(text = ''): TimeUnitOptions | null {
  if (text.match(/^(mo|month|months)$/i)) {
    return 'mo';
  } else if (text.match(/^(m|min|minute|minutes)$/i)) {
    return 'm';
  } else if (text.match(/^(h|hour|hours)$/i)) {
    return 'h';
  } else if (text.match(/^(d|day|days)$/i)) {
    return 'd';
  } else if (text.match(/^(y|year|years)$/i)) {
    return 'y';
  } else if (text.match(/^(w|week|weeks)$/i)) {
    return 'w';
  } else if (text.match(/^(s|sec|second|seconds)$/i)) {
    return 's';
  } else {
    return null;
  }
}

function toMomentUnit(unit: TimeUnitOptions | null) {
  switch (unit) {
    case 's':
      return 'seconds';
    case 'm':
      return 'minutes';
    case 'h':
      return 'hours';
    case 'd':
      return 'days';
    case 'w':
      return 'weeks';
    case 'mo':
      return 'months';
    case 'y':
      return 'years';
  }
}

function getPeriods(text = ''): number | null {
  if (text.indexOf('.') !== -1) {
    return parseFloat(text);
  }

  return parseInt(text);
}
